import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/customization/appsetup/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

import { Offcanvas } from "react-bootstrap";

function Edit({ show, onHide, id, setShowError, setSuccess, setErr }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");
  const advertisementimageFile = watch("advertisement_image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("support_contact_no", data?.support_contact_no);
      sendData.append("min_withdrawl_amount", data?.min_withdrawl_amount);
      sendData.append("min_fund_deposit", data?.min_fund_deposit);
      sendData.append("min_driver_amount", data?.min_driver_amount);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        setSuccess(true);
        setModalShow(true);
        setTimeout(() => {
          onHide();
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit App Set Up</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                <div className="form-group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Name"
                    {...register("name", {
                      required: "Name is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.name,
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name?.message}</span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Support Contact Number</Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Name"
                    {...register("support_contact_no", {
                      required: "Support Contact Number is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.support_contact_no,
                    })}
                  />
                  {errors.support_contact_no && (
                    <span className="text-danger">
                      {errors.support_contact_no?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Minumum Withdrawal Amount</Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Min Withdrawal Amount"
                    {...register("min_withdrawl_amount", {
                      required: "Min Withdrawal Amount  is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.min_withdrawl_amount,
                    })}
                  />
                  {errors.min_withdrawl_amount && (
                    <span className="text-danger">
                      {errors.min_withdrawl_amount?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Minumum Fund Deposit </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Min Withdrawal Amount"
                    {...register("min_fund_deposit", {
                      required: "Min Withdrawal Amount  is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.min_fund_deposit,
                    })}
                  />
                  {errors.min_fund_deposit && (
                    <span className="text-danger">
                      {errors.min_fund_deposit?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Minumum Driver Amount </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Min Driver Amount"
                    {...register("min_driver_amount", {
                      required: "Min Driver Amount  is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.min_driver_amount,
                    })}
                  />
                  {errors.min_driver_amount && (
                    <span className="text-danger">
                      {errors.min_driver_amount?.message}
                    </span>
                  )}
                </div>


                
                

                

                
              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        onHide();
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Successfull_Modal
          message={"Successful"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Edit;
